import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {Checkbox} from 'web-components';
import Util from '../../forecast-app/shared/util/util';
import UpdateCompanyToBeDeletedMutation from '../../mutations/mission_control/update_company_to_be_deleted_mutation';

class CompaniesToBeDeleted extends Component {
	changeToBeDeleted(companyId, currentValue) {
		Util.CommitMutation(UpdateCompanyToBeDeletedMutation, {
			companyId: companyId,
			toBeDeleted: !currentValue,
		});
	}

	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		const style = {position: 'sticky', top: 0, background: 'white'};

		return (
			<div className="mission-control-list">
				<h1>Companies To Be Deleted</h1>
				<table>
					<tbody>
						<tr>
							<th style={style}>Id</th>
							<th style={style}>Name</th>
							<th style={style}>Created At</th>
							<th style={style}>Trial End Date</th>
							<th style={style}>Last session Date</th>
							<th style={style}>Project count</th>
							<th style={style}>User count</th>
							<th style={style}>Flagged Date</th>
							<th style={style}>Domains</th>
							<th style={style}>To Be Deleted</th>
						</tr>
						{this.props.viewer.missionControlData.companiesToBeDeleted.map(company => {
							return (
								<tr key={company.companyId}>
									<td>{company.companyId}</td>
									<td>{company.name}</td>
									<td>{company.createdAt}</td>
									<td>{company.trialEndDate}</td>
									<td>{company.lastSessionDate}</td>
									<td>{company.projectCount}</td>
									<td>{company.userCount}</td>
									<td>{company.flaggedForDeletionDate}</td>
									<td>{company.domains}</td>
									<td>
										<Checkbox
											checked={company.toBeDeleted}
											onClick={this.changeToBeDeleted.bind(this, company.companyId, company.toBeDeleted)}
										/>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);
	}
}

const companiesToBeDeletedQuery = graphql`
	query companiesToBeDeleted_Query {
		viewer {
			actualPersonId
			component(name: "control_companies_to_be_deleted")
			...companiesToBeDeleted_viewer
		}
	}
`;

export {companiesToBeDeletedQuery};

export default createFragmentContainer(withRouter(CompaniesToBeDeleted), {
	viewer: graphql`
		fragment companiesToBeDeleted_viewer on Viewer {
			id
			actualPersonId
			missionControlData {
				id
				companiesToBeDeleted {
					id
					companyId
					createdAt
					name
					trialEndDate
					lastSessionDate
					projectCount
					userCount
					flaggedForDeletionDate
					domains
					toBeDeleted
				}
			}
		}
	`,
});
